import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import AnimatedModal from "components/Modal/AnimatedModal";
import { playgroundTypes } from "domain/Directories/types";
import PlaygroundDetailsFields from "components/PlaygroundDetails/Fields";
import Slider from "components/Slider";
import Ul from "ui/Ul";
import Avatar from "ui/Avatar";
import Button from "ui/Button";

const PlaygroundDetails = (props) => {
    const {
        onClose,
        minWidth,
        playground,
        cityName,
        options,
        onSelect,
        dontShowModal,
        containerClassName,
        isMobile,
        isDesktop,
        isTablet,
        modalModificators,
        showInModal,
        modalTitle,
        hideCloseButton,
        bodyModificators,
        type,
    } = props;

    const onSave = () => {
        onSelect(playground);
        onClose();
    };

    let content = (
        <>
            {minWidth >= 1280 && !hideCloseButton && (
                <button
                    type="button"
                    onClick={onClose}
                    className="sidebar-right__close-wrapper"
                >
                    <span className="sidebar-right__close-text fs-caption hide-desktop-down">
                        Скрыть
                    </span>
                    <span className="close sidebar-right__close" />
                </button>
            )}

            <Avatar
                imgUrl={
                    playground?.media?.length ? playground.media[0].url : null
                }
                name={playground.name}
                col={isTablet}
            />

            <PlaygroundDetailsFields
                playground={playground}
                cityName={cityName}
                type={type}
            />

            {options.length > 0 && (
                <>
                    <p
                        className={cn("fs-body2 ", {
                            "c-gs-medium-em": !isMobile,
                            "text_gs-label": isMobile,
                        })}
                    >
                        Что есть:{" "}
                    </p>
                    <Ul items={options.map((option) => option.name)} />
                </>
            )}

            {isDesktop && playground?.media?.length > 0 && (
                <Slider images={playground.media} />
            )}

            {onSelect && (
                <Button primary fullWidth onClick={onSave}>
                    Выбрать площадку
                </Button>
            )}
        </>
    );

    if ((minWidth < 1280 && !dontShowModal) || showInModal) {
        return (
            <AnimatedModal
                modificators={modalModificators}
                title={modalTitle}
                onClose={onClose}
                closeOnOverlay={showInModal}
                bodyModificators={bodyModificators}
            >
                {() => content}
            </AnimatedModal>
        );
    }
    return <div className={containerClassName}>{content}</div>;
};

PlaygroundDetails.defaultProps = {
    containerClassName: "sidebar-right__inner",
    modalModificators: [`tablet-page`],
    showInModal: false,
    modalTitle: `Выбрать площадку`,
    hideCloseButton: false,
    bodyModificators: [`blur-off`],
};

PlaygroundDetails.propTypes = {
    playground: playgroundTypes,
    playgroundId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    minWidth: PropTypes.number,
    cityName: PropTypes.string,
    type: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }),
    options: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func,
    dontShowModal: PropTypes.bool,
    containerClassName: PropTypes.string,
    isMobile: PropTypes.bool,
    isDesktop: PropTypes.bool,
    isTablet: PropTypes.bool,
    modalModificators: PropTypes.array,
    bodyModificators: PropTypes.array,
    modalTitle: PropTypes.string,
    showInModal: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
};

export default PlaygroundDetails;
